import X509ChainStatusFlags from '../store/schema/X509ChainStatusFlags';
import { default as getFlagToErrorMessageDictionary } from './getSmimeSignatureStatusFlagToErrorMessageDictionary';

const getSmimeSignatureErrorMessages = (serverVerificationResult?: number): string[] => {
    const smimeSignatureErrors: string[] = [];

    if (!serverVerificationResult) {
        return smimeSignatureErrors;
    }

    const flagToErrorMessageDictionary = getFlagToErrorMessageDictionary();

    if (serverVerificationResult === X509ChainStatusFlags.CertificateDataCorrupted) {
        smimeSignatureErrors.push(
            flagToErrorMessageDictionary[X509ChainStatusFlags.CertificateDataCorrupted]
        );
    } else {
        let errorFlag = 1;

        while (errorFlag <= serverVerificationResult) {
            if (serverVerificationResult & errorFlag) {
                const errorMessage: string = flagToErrorMessageDictionary[errorFlag];
                errorMessage && smimeSignatureErrors.push(errorMessage);
            }

            // Shift current set bit to left
            errorFlag = errorFlag << 1;
        }
    }

    return smimeSignatureErrors;
};

export default getSmimeSignatureErrorMessages;
